import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

import { ToastService } from "@shared/service/toast.service";
import { MessageType } from "@schema/message";
import { AuthService } from "@core/service/auth.service";
import { first } from "rxjs/operators";

@Component({
  selector: "app-change-profile-modal",
  templateUrl: "./change-profile-modal.component.html",
  styleUrls: ["./change-profile-modal.component.scss"]
})
export class ChangeProfileModalComponent implements OnInit {

  /**
   * The form used on this modal
   */
  public form: FormGroup;

  public loading = false;

  /**
   * Grab the form controls
   */
  get formControls() {
    return this.form.controls;
  }

  constructor(
    public modal: NgbActiveModal,
    protected _fb: FormBuilder,
    protected _toastService: ToastService,
    protected _authService: AuthService,
  ) { }

  ngOnInit() {
    // Setup the form
    this.form = this._fb.group({
      firstName: [
        null,
        [
          Validators.required
        ]
      ],
      lastName: [
        null,
        [
          Validators.required
        ]
      ],
      email: [
        null,
        [
          Validators.required,
          Validators.email
        ]
      ],
    });

    this._authService.user$.pipe(first()).subscribe((user) => {
      this.form.setValue({
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.emailAddress
      });
    });
  }

  public submit() {
    this.loading = true;

    const parent = this;
    // TODO: Call the user endpoint to set new profile info

    // Dummy loading time / success:
    window.setTimeout(() => {
      parent.modal.close();
      parent.loading = false;
      parent._toastService.add({
        title: "Success!",
        body: `Your profile has been updated!`,
        type: MessageType.SUCCESS,
        autohide: true
      });
    }, 1000);
  }
}
